// src/helpers/scanFeedback.ts
// Tiếng "beep" phản hồi tức thì khi quét vé bằng máy quét cầm tay (Honeywell) ở màn Giao vé / Thu hồi.
// README_QR_SCAN_PERFORMANCE.md nhấn mạnh nhân viên quầy cần beep xanh/đỏ NGAY để giữ nhịp quét —
// không chờ round-trip. Dùng Web Audio API có sẵn, không thêm thư viện, không tải file âm thanh.
//
// AudioContext chỉ được tạo (và resume) SAU một thao tác người dùng (bấm "Bắt đầu quét") để không bị
// trình duyệt chặn autoplay.

let audioContext: AudioContext | null = null;

const getContext = (): AudioContext | null => {
  if (typeof window === 'undefined') return null;
  const Ctor = window.AudioContext || (window as any).webkitAudioContext;
  if (!Ctor) return null;
  if (!audioContext) audioContext = new Ctor();
  // Trình duyệt có thể để context ở trạng thái "suspended" tới khi có user-gesture.
  if (audioContext.state === 'suspended') audioContext.resume().catch(() => undefined);
  return audioContext;
};

// Phát 1 nốt: tần số (Hz), thời lượng (ms), âm lượng (0..1).
const tone = (frequency: number, durationMs: number, volume = 0.15, startOffsetMs = 0): void => {
  const ctx = getContext();
  if (!ctx) return;
  const startAt = ctx.currentTime + startOffsetMs / 1000;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'square';
  osc.frequency.setValueAtTime(frequency, startAt);
  // Fade nhẹ 2 đầu để không bị "tách" chói tai.
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(volume, startAt + 0.005);
  gain.gain.setValueAtTime(volume, startAt + durationMs / 1000 - 0.01);
  gain.gain.linearRampToValueAtTime(0, startAt + durationMs / 1000);
  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + durationMs / 1000);
};

// Gọi 1 lần trong handler của user-gesture (nút "Bắt đầu quét") để "mở khoá" audio trước khi quét.
export const primeScanAudio = (): void => {
  getContext();
};

// Vé hợp lệ — 1 nốt cao, ngắn, dứt khoát.
export const beepOk = (): void => {
  tone(1180, 90, 0.14);
};

// Vé bị loại (không thuộc dải / sai kỳ / sai định dạng) — 2 nốt trầm, dài hơn, dễ nhận ra là "lỗi".
export const beepReject = (): void => {
  tone(320, 150, 0.18, 0);
  tone(240, 200, 0.18, 150);
};

// Vé đã có trong danh sách (quét trùng) — 1 nốt trung tính, rất ngắn.
export const beepDuplicate = (): void => {
  tone(620, 70, 0.1);
};
